import React, { DetailedHTMLProps, FC, HTMLAttributes, useRef } from 'react'
import styles from './Checkbox.module.scss'

type CheckboxProps = {
  checked: boolean
  required?: boolean
  onChange: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
  lineclamp?: boolean
}

const Checkbox: FC<
  CheckboxProps &
    DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
> = ({ checked, onChange, className, required, children }, ...args) => {
  const ref = useRef<HTMLInputElement>(null)

  return (
    <div
      onClick={() => ref.current?.click()}
      className={`${styles.container} cursor-pointer ${className}`}
    >
      <input
        className="cursor-pointer"
        ref={ref}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e)}
        required={required}
      />
      {children}
    </div>
  )
}

export default Checkbox
